"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _linkExternal = _interopRequireDefault(require("@atlaskit/icon/core/link-external"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ShortcutIcon = props => /*#__PURE__*/_react.default.createElement(_base.UNSAFE_IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
}, props, {
  newIcon: _linkExternal.default
}));
ShortcutIcon.displayName = 'ShortcutIcon';
var _default = exports.default = ShortcutIcon;